// import React from "react";
// import "../../Utility/css/cardLayout.css";
// import { ArrowRightOutlined, ThunderboltOutlined } from "@ant-design/icons";
// import "./HeroSection.css";
// import { Button } from "antd";
// const HeroSection: React.FC = () => {
//   const handleStartTrial = () => window.location.href = "/sign-up";
//   const handleRequestDemo = () => window.location.href = "/requestdemo";

//   return (
//     <div className="heroContent">
//       <span className="heroBadge">
//         <ThunderboltOutlined /> Next-Gen Solutions
//       </span>
//       <div className="heroTitleBody">
//         <h3 className="heroTitle">
//           Automate Your Manufacturing Workflow And Enhance Your Margin With Ease
//         </h3>
//         <div className="heroSubTitle">
//           {`Streamline your manufacturing process, create documents for your sales and purchases, manage inventory, fetch real-time data, and generate reports as per requirement.`}
//         </div>
//         <div>
//           <Button
//             type="primary"
//             onClick={handleStartTrial}
//             style={{
//               backgroundColor: "#1780FB",
//               color: "#ffffff",
//             }}
//           >
//             Start Your Free Trial <ArrowRightOutlined />
//           </Button>
//           <Button onClick={handleRequestDemo}>Request a Demo</Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeroSection;

import React from "react";
import "../../Utility/css/cardLayout.css";
import { ArrowRightOutlined, ThunderboltOutlined } from "@ant-design/icons";
import "./HeroSection.css";
import { Button } from "antd";
import frame from "../Components/images/Frame.png";


const HeroSection: React.FC = () => {
  const handleStartTrial = () => (window.location.href = "/sign-up");
  const handleRequestDemo = () => (window.location.href = "/requestdemo");

  return (
    <div className="heroContainer">
      {/* Left Side - Text */}
      <div className="heroText">
        <span className="heroBadgeMain">
          <ThunderboltOutlined /> Next-Gen Solutions
        </span>

        <h3 className="heroTitleMain">
          Automate Your Manufacturing Workflow And Enhance Your Margin With Ease
        </h3>

        <div className="heroSubTitleMain">
          From <strong style={{ color: '#1780fb' }}>Inventory</strong> to <strong style={{ color: '#1780fb' }}>Production</strong><br /> managed with ease.
        </div>

        <div className="heroButtons">
          {/* <Button
            type="primary"
            onClick={handleStartTrial}
            style={{
              backgroundColor: "#1780FB",
              color: "#ffffff",
            }}
          >
            Start Your Free Trial <ArrowRightOutlined />
          </Button> */}
          <Button type="primary" onClick={handleRequestDemo}>Request a Demo</Button>
        </div>
      </div>

      {/* Right Side - Image */}
      <div className="rounded-2xl overflow-hidden w-full h-[220px] md:h-[500px] lg:w-[90%] lg:h-[60vh] bg-black">
        <video
          src="./EasePromo.mp4"
          autoPlay
          muted
          loop
          controls
          className="w-full h-full object-cover"
        />
      </div>

      {/* <div className="heroImage">
        <img src={frame} alt="Hero" />
        
      </div> */}
    </div>
  );
};

export default HeroSection;
